import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import apiCenter from '../../services/service_undefined'
// import Swal from 'sweetalert2'
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      search_keyword: '',
      title: 'จัดการสิทธิ์ผู้ใช้งาน',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      active: 1,
      modal_active: false,
      modal_data: {
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      },
      modal_title: '',
      data_list: [],
      data_search:[],
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      this.currentPage = 1
      return this.data_list.filter(userlist => {
        if(userlist.role_code == null) userlist.role_code = ''
        return (
          userlist.role_code.indexOf(text) > -1 || userlist.role_name.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.active = pageNumber
    },
    getList () {
      // this.$store.commit('Loading')
      apiCenter.roleUser(
        this.header,
        result => {
          this.data_list = result.data;
          this.data_search = result.data;
          // this.$store.commit('Loading');
        },
        error => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    goToPage (path, code) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push({ name: path, params: { role_code: code } })
    },
    textSearch () {
      this.search_keyword  = this.search_keyword.toLowerCase();
      if (this.search_keyword === "") {
        this.data_list = this.data_search;
      } else {
        this.data_list = this.data_search.filter(
          (x) =>
            x.role_code.toLowerCase().includes(this.search_keyword) ||
            x.role_name.toLowerCase().includes(this.search_keyword)
        );
      }
    },
    editUser (val) {
      this.goToPage('role_menage_detail', val.role_code)
    },
    removeUser (val) {
      // this.$store.commit('Loading')
      let body = {
        'role_code': val.role_code ,
        'active_status': 0
      }
      apiCenter.roleUserDelete(body,
        this.header,
        result => {
          if(result.data.success) {
            this.data_list = result.data.result;
            this.data_search = result.data.result;
            this.alert_msg('success', 'ลบข้อมูลสำเร็จ', result.message)
           } else {
            this.alert_msg("warning", "ไม่สามารถลบข้อมูลได้ เนื่องจากถูกนำไปใช้กับหน้าจอผู้ใช้งาน", null);
           }

          // this.$store.commit('Loading');
        },
        error => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    doing () {
      alert('รอดำเนินการ')
    },
  },
  mounted () {
    this.$store.state.historyPage = ''
    this.checkUser()
    this.getList()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/role_list.js